/** @jsx jsx */
import { jsx } from '@emotion/react'
import { OndeEstamosStyles } from '../assets/styles/OndeEstamos.styles'
import { Col, Container, Row } from 'react-bootstrap'
import { input, form } from "../assets/styles/FormSection.styles";
import ImgPreMatricula from '../assets/images/LP-arabe/pre-matricula.jpg'

const OndeEstamosContent = () => {
  return (
    <section css={OndeEstamosStyles}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='form-sec'>
          <Col lg={5} md={5} sm={12} className="d-none d-md-block">
            <img src={ImgPreMatricula} />
          </Col>
          <Col lg={1} md={1} sm={12} />
          <Col lg={5} md={5} sm={12}>
            <h2>Faça aqui a pré-matrícula na <span style={{ color: '#F26F33' }}>Escola Árabe Bertoni!</span></h2>
            <div>
                <form
                  name='pre-matricula'
                  method='POST'
                  action='/sucesso'
                  data-netlify='true'
                  css={form}
                >
                  <input
                    type='hidden'
                    name='form-name'
                    value='pre-matricula'
                  />
                  <div className='text_input_containe'>
                    <div>
                      <label className='text-label'>Nome do(a) aluno(a)*</label>
                      <input
                        className='text_input'
                        type="text"
                        name="nome"                        
                        required
                      />
                    </div>
                    <div>
                      <label className='text-label'>Nome do(a) responsável*</label>
                      <input
                        className='text_input'
                        type="text"
                        name="nome-reponsavel"                        
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>E-mail</label>
                      <input
                        className='text_input'
                        type="mail"
                        name="email"
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>Celular</label>
                      <input
                        className='text_input'
                        type="tel"
                        name="celular"
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>Escola de origem</label>
                      <input
                        className='text_input'
                        type="text"
                        name="escola"
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>Turma de interesse</label>
                      <input
                        className='text_input'
                        type="text"
                        name="turma-interesse"
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>Melhor horário para contato</label>
                      <input
                        className='text_input'
                        type="text"
                        name="horario-contato"
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>Como soube da Escola Árabe?</label>
                      <textArea
                        className='text_input'
                        type="text"
                        name="mensagem"
                        required
                      />
                    </div>
                  </div>
                  <button type='submit'>
                    Enviar
                  </button>
                </form>
              </div>
          </Col>
          <Col lg={1} md={1} sm={12} />
        </Row>
      </Container>
      {/* <img src={studentWithTeacher} alt="Crianças juntas com a professora" /> */}
    </section>
  )
}

export default OndeEstamosContent;
